//@flow
import queryData from '../Utils/query-string-data';
import _ from 'underscore';
import CookiesData from '../Utils/cookies-data';
import UrlData from '../Utils/url-data';

import type { RouteReplace, RouteCallback, RouteState } from 'react-router';

export function inBrowser() {
  return global && global.location && (!process || (process:any).browser); // eslint-disable-line no-undef
}

/*
  This handler serves 2 purposes.
  1. If you are attempting to do a client side transition to a route that is outside
     of the current router, it will reload the page to transition into the correct router.
  2. If you are doing server side rendering and get into this block, you've got a 404
     situation so we add a property to track that and assume that we'll handle the 404
     rendering in the main node request handler.
*/
export function noMatchHandler(nextState:RouteState, replace:RouteReplace, callback:RouteCallback) {
  if (inBrowser()) {
    global.location = global.location.href;
  }
  else {
    nextState.is404 = true;
    callback();
  }
}

export function isQueryPreserved(search:string) {
  const newQuery = UrlData.getParsedQuery(search);
  const checkoutQuery = queryData.getCheckoutQueryParams();
  Object.assign(checkoutQuery, newQuery);
  return _.isEqual(checkoutQuery, newQuery);
}

export function setQuery(fixedQuery:{[string]:string}, nextState:RouteState, replace:RouteReplace) {
  Object.assign(fixedQuery, nextState.location.query);

  if (_.isEqual(fixedQuery, nextState.location.query)) return;

  const fixedLocation = Object.assign({}, nextState.location);
  fixedLocation.query = fixedQuery;
  queryData.updatePreservedQueryParams(fixedQuery);
  replace(fixedLocation);
}

/*
  This function replaces the nextState location for a location with the right
  query, adding all the necessary marketing query params. If there is no change
  to be made it won't perform the location replace.
*/
export function onChangeHook(prevState:?RouteState, nextState:RouteState, replace:RouteReplace, callback:RouteCallback) {
  setQuery(queryData.getCheckoutQueryParams(), nextState, replace);
  callback();
}

// This handler is for requiring authentication on a route. It should be set as an
// onEnter hook for a route.
export function requireAuth(nextState:RouteState, replace:RouteReplace, callback:RouteCallback) {
  if (inBrowser()) {
    const userData = CookiesData.getUser();

    if (!userData || (userData.scope && userData.scope !== 'customer')) {
      const loc = nextState.location;
      const query = Object.assign({}, loc.query, { location: loc.pathname.slice(1) });
      replace({ pathname: '/signin', query });
    }
  }

  callback();
}
